import { create } from 'zustand';

const useLoadingStatus = create((set) => ({
  isStatusChange: false,
  setStatusChange: (status) => set({ isStatusChange: status })
}));

export default useLoadingStatus;
